const initSidebar = () => {
    //get sidebar
    const sidebarComponent = document.querySelector("[data-sidebar]");
    //if there is a sidebar in page and we are below the ipad classic width
    if (sidebarComponent && window.innerWidth <= 767) {
        //clone node and its children recursively
        const sidebarClone = sidebarComponent.cloneNode(true);
        //add class cloned
        sidebarClone.classList.add("cloned");
        //set data attribute to activate toggle
        sidebarClone.setAttribute("data-to-be-toggled", "mobile-sidebar");
        //append to body
        document.body.appendChild(sidebarClone);
        initToggler("mobile-sidebar");
    }
};
const initHighlightSidebarOnScroll = () => {
    const sidebarWidget = document.querySelector("[data-sidebar]");
    if (sidebarWidget) {
        const listsSidebarArray = sidebarWidget.querySelectorAll("[data-anchor]");
        const sectionOnContainerBodyPageArray = document.querySelectorAll("[data-sidebar-item]");
        window.addEventListener("scroll", () => {
            sectionOnContainerBodyPageArray.forEach((sectionOnContainerBodyPage) => {
                if (isElementInViewport(sectionOnContainerBodyPage)) {
                    listsSidebarArray.forEach((listSidebar) => {
                        if (sectionOnContainerBodyPage.getAttribute("id") == listSidebar.getAttribute("href").replace(/#/, "")) {
                            for (let i = 0; i < listsSidebarArray.length; i++) {
                                listsSidebarArray[i].parentElement.classList.remove("active");
                            }
                            if (!listSidebar.classList.contains("active")) {
                                listSidebar.parentElement.classList.add("active");
                            }
                        }
                    });
                }
            });
        });
    }
};
const isElementInViewport = (element, offset = 0) => {
    const rect = element.getBoundingClientRect();
    const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
    return (rect.bottom >= -offset &&
        rect.right >= 0 &&
        rect.top <= viewportHeight / 5 + offset &&
        rect.left <= (window.innerWidth || document.documentElement.clientWidth));
};
